module.exports = __webpack_public_path__ + "static/rera-letter-1-64732c8f185d2918d8648d21c6a3e168.jpg";